import React, { useContext } from 'react';
import { Context } from '@store/store';
import GoBackToMainMenuButton from '../go-back-to-main-menu-button';
import { LazyImage } from './LazyImage';
import {
  StyledThumbnailsSidebar,
  StyledThumbnail,
  ThumbnailsGrid,
  Header,
  StyledLine,
} from './thumbnails-sidebar.styles';

const ThumbnailsSidebar = ({ thumbnails }) => {
  const [state] = useContext(Context);
  return (
    <StyledThumbnailsSidebar isOpened={state.isThumbnailsSidebarOpened}>
      <Header>
        <GoBackToMainMenuButton />
        <span>Оглавление</span>
        <span></span>
      </Header>
      <StyledLine />
      <ThumbnailsGrid>
        {thumbnails.map((thumbnail, index) => {
          return <Thumbnail key={index} src={thumbnail} page={index + 1} />;
        })}
      </ThumbnailsGrid>
    </StyledThumbnailsSidebar>
  );
};

const Thumbnail = ({ page, src }) => {
  const [state, dispatch] = useContext(Context);

  return (
    <StyledThumbnail
      onClick={() => {
        dispatch({
          type: 'SET_CURRENT_PAGE',
          payload: page - 1,
        });
        dispatch({ type: 'TOGGLE_MAIN_MENU_SIDEBAR' });
      }}
      isActive={state.currentPage === page - 1}
    >
      <LazyImage src={src} alt={`Эскиз страницы номер ${page}`} />
      <span>{page}</span>
    </StyledThumbnail>
  );
};

export default ThumbnailsSidebar;
